import { render, staticRenderFns } from "./BoxSearch.vue?vue&type=template&id=7165a128"
import script from "./BoxSearch.vue?vue&type=script&lang=js"
export * from "./BoxSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports